import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { AuditPage } from './AuditPage';

/** Screens of this feature (A3). */
export const routes: FeatureRoute[] = [
  {
    path: 'audit',
    element: (
      <RequireCapability anyOf={['audit.view']} what="the audit log">
        <AuditPage />
      </RequireCapability>
    ),
  },
];
